import templateUrl from '../views/modals/single-message-modal.tpl.html';
import VoucherSingleMessageModalController from "../controllers/modals/single-send/voucher-single-message-modal";

export default function voucherSingleMessageModalCreator($injector, voucher, extendedInformation) {
    extendedInformation = _.isObject(extendedInformation) ? extendedInformation : {};
    return $injector.get('$uibModal').open({
        controller: VoucherSingleMessageModalController,
        controllerAs: 'vm',
        size: 'xlg',
        templateUrl,
        backdrop: 'static',
        windowClass: 'modal-fixed',
        keyboard: false,
        resolve: {
            extendedInformation: () => ({
                ...extendedInformation,
                recipientModel: voucher,
                contact: voucher.contact
            })
        }
    }).result;
}



// WEBPACK FOOTER //
// ./src/app/modules/messages/helpers/voucher-single-message-modal-creator.js